import { render, staticRenderFns } from "./sensitiveWord-list.vue?vue&type=template&id=141ffbeb&scoped=true"
import script from "./sensitiveWord-list.vue?vue&type=script&lang=js"
export * from "./sensitiveWord-list.vue?vue&type=script&lang=js"
import style0 from "./sensitiveWord-list.vue?vue&type=style&index=0&id=141ffbeb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141ffbeb",
  null
  
)

export default component.exports